import { type DependencyList, useCallback } from 'react';

import { useStableEventCallback } from './useStableEventCallback';

export const useRenderStabilizedCallback = <Args extends unknown[], ReturnValue>(
	callback: (...args: Args) => ReturnValue,
	deps: DependencyList,
	isRenderStabilizationEnabled: boolean,
): ((...args: Args) => ReturnValue) => {
	// The disabled path still updates the stable-event ref each render; that tiny cost keeps this
	// hook type-honest and avoids branching around hook calls.
	const stableCallback = useStableEventCallback(callback);
	// eslint-disable-next-line react-hooks/exhaustive-deps -- preserve the caller's existing useCallback dependency contract while the experiment is disabled.
	const controlCallback = useCallback(callback, deps);

	return isRenderStabilizationEnabled ? stableCallback : controlCallback;
};
